<template>
<!-- begin:: Footer -->
<div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
						<!--begin::Container-->
	<div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
		<!--begin::Copyright-->
		<!-- <div class="text-dark order-2 order-md-1">
			<span class="text-muted font-weight-bold mr-2">2020©</span>
			<a href="http://www.ordercircle.com" class="menu-link">OrderCircle</a>
		</div> -->
		<!--end::Copyright-->
		<!--begin::Nav-->
		<!-- <div class="nav nav-dark">
			<a href="" target="_blank" class="nav-link pl-0 pr-5">Link 1</a>
			<a href="" target="_blank" class="nav-link pl-0 pr-5">Link 2</a>
			<a href="" target="_blank" class="nav-link pl-0 pr-0">Link 3</a>
		</div> -->
		<!--end::Nav-->
	</div>
	<!--end::Container-->
</div>

<!-- end:: Footer -->
</template>
<script>
export default {
  name: 'shop-footer',
};
</script>
<style scoped>
	.footer{
		position: fixed;
		bottom: 0;
		width: 100%;
	}
</style>